import * as React from 'react';

import { getAppStore } from '~src/app/AppStore';
import { SessionSiteSelectors } from '~src/app/selectors/SessionInfoSelectors';

import { Messages } from '../../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../../commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '../../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const OWNER_ALLOWED_FOR_ACCELERATION_FIELD = 'settings.canOwnerAccelerate';

export type DataAccelerationSectionProps = SiteSettingsForSiteAdminProps<'canOwnerAccelerate'>;

export function DataAccelerationSection(props: DataAccelerationSectionProps) {
  return FeatureFlags.workbookAccelerationUIEnabled
    && SessionSiteSelectors.canOwnerAccelerate(getAppStore().getState()) !== undefined
    ? (
      <SettingsSection title={Messages.workbookAcceleration()}
                       testId={'data-acceleration-setting-section'}
                       description={Messages.allowOwnerToAccelerate()}>
        <FormikCheckbox
                    name={OWNER_ALLOWED_FOR_ACCELERATION_FIELD}
                    label={Messages.enableWorkbookOwnerToAccelerate()}
                    testId={'data-acceleration-checkbox'}
        />
      </SettingsSection>
    )
    : null;
}

export const DataAccelerationSectionSpecs = componentRegistryEntry({
  name: 'DataAccelerationSection',
  component: DataAccelerationSection
});
